// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shipFromAltDCModalStyles } from "@guestsupply/App/Components/BackorderManagement/ShipFromAltDCModal";
import { color } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

shipFromAltDCModalStyles.shipFromAltDCModal = {
    size: 750,
};

shipFromAltDCModalStyles.confirmShipFromAltDCModal = {
    size: 500,
    cssOverrides: {
        modalTitle: css`
            &&& {
                border: none;
                min-height: 30px;
            }
        `,
    },
};

shipFromAltDCModalStyles.confirmShipFromAltDCTitle = {
    weight: "normal",
    css: css`
        margin-bottom: 30px;
    `,
};

shipFromAltDCModalStyles.descriptionText = {
    as: "p",
};

shipFromAltDCModalStyles.availableAltWarehouseWrapper = {
    css: css`
        padding: 20px;
        margin-top: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 2px solid ${color("common.ui3")};
    `,
};

shipFromAltDCModalStyles.shipFromCurrentWrapper = {
    css: css`
        display: flex;
        padding: 20px;
        margin: 30px -20px -20px;
        border-radius: 0px 0px 4px 4px;
        background-color: ${color("common.ui2")};
    `,
};

shipFromAltDCModalStyles.selectButton = {
    css: css`
        margin-left: 10px;
    `,
};

shipFromAltDCModalStyles.shipFromCurrentButton = {
    css: css`
        white-space: nowrap;
        margin-right: 15px;
    `,
};
